import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConsentScopesService {
    private readonly consentScopes: string[] = [
        "user.read",
        "openid",
        "profile"
    ];

    getConsentScopes(): string[] {
        return this.consentScopes;
    }
}
